<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="thisdate"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="thisdate"
        v-bind="attrs"
        v-on="on"
        autocomplete="off"
        readonly
        :label="label"
        outlined
        @click="openDateTime()"
      ></v-text-field>
    </template>
    <div id="myDIV" @wheel="wheelIng()">
      <v-date-picker
        v-model="thisdate"
        no-title
        scrollable
        :max="max"
        :events="availableHolidayDates"
        ref="datepicker"
        event-color="white"
        @click:month="openDateTime()"
        v-if="disable_future"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="Choose()">OK</v-btn>
      </v-date-picker>
      <v-date-picker
        v-model="thisdate"
        no-title
        scrollable
        :min="max"
        :events="availableHolidayDates"
        ref="datepicker"
        event-color="white"
        @click:month="openDateTime()"
        v-else-if="disable_past"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="Choose()">OK</v-btn>
      </v-date-picker>
      <v-date-picker
        v-model="thisdate"
        no-title
        scrollable
        :events="availableHolidayDates"
        ref="datepicker"
        event-color="white"
        @click:month="openDateTime()"
        v-else
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="Choose()">OK</v-btn>
      </v-date-picker>
    </div>
  </v-menu>
</template>

<script>
import moment from "moment";
import holiday from "../assets/americanholiday.json";
import holidays from "../assets/americandynamicholidays.json";

export default {
  name: "DatePicker",
  data: () => ({
    menu: false,
    derived: moment(new Date()).format("YYYY-MM-DD"),
    max: moment(new Date()).format("YYYY-MM-DD"),
    availableHolidayDates: [],
    holidayControl: 0,
    dynamciHolidays: [
      "Martin Luther King, Jr. Day",
      "President's Day",
      "Memorial Day",
      "Labor Day",
      "Columbus Day",
      "Thanksgiving Day",
    ],
  }),
  props: ["modal", "date", "label", "disable_future", "disable_past"],
  async updated() {
    await this.$nextTick();
    const prevBtn = this.$refs.datepicker.$el.querySelector(
      '.v-btn[aria-label="Previous month"]'
    );
    prevBtn.addEventListener("click", () => {
      if (this.holidayControl === 1) {
        this.holidayControl = 0;
        this.dateTimer();
      }
    });
    const nextBtn = this.$refs.datepicker.$el.querySelector(
      '.v-btn[aria-label="Next month"]'
    );
    nextBtn.addEventListener("click", () => {
      if (this.holidayControl === 1) {
        this.holidayControl = 0;
        this.dateTimer();
      }
    });
  },
  computed: {
    thisdate: {
      get: function() {
        return moment(this.date).isValid()
          ? moment(this.date).format("YYYY-MM-DD")
          : this.date;
      },
      set: function(d) {
        this.derived = d;
      },
    },
  },
  methods: {
    Choose: function() {
      var view = this;
      view.$refs.menu.save(moment(view.derived).format("YYYY-MM-DD hh:mm:ss"));
      view.$emit("choose", moment(view.derived).format("YYYY-MM-DD hh:mm:ss"));
    },
    openDateTime() {
      setTimeout(() => this.dateTimer(), 100);
    },
    wheelIng() {
      if (this.holidayControl === 1) {
        this.holidayControl = 0;
        this.dateTimer();
      }
    },
    dateTimer() {
      let view = this;
      let a = [];
      for (let i = 0; i < holiday.length; i++) {
        a.push(
          holiday[i].occurrence.replace(
            "2020",
            view.$refs.datepicker.tableYear.toString()
          )
        );
      }
      for (let j = 0; j < view.dynamciHolidays.length; j++) {
        a.push(
          view.getDateString(
            view.dynamciHolidays[j],
            view.$refs.datepicker.tableYear
          )
        );
      }
      view.availableHolidayDates = a;
      setTimeout(() => view.getEventsList(), 100);
    },
    getEventsList() {
      var eventsDates = document.querySelectorAll(
        ".v-date-picker-table .v-btn"
      );
      for (var i = 0; i < eventsDates.length; i++) {
        let nextSibling = eventsDates[i].children;
        if (nextSibling[1] != undefined) {
          nextSibling[0].style.color = "#ff0000";
        }
      }
      this.holidayControl = 1;
    },
    getDate(year, holiday) {
      let month = Number.parseInt(holiday[0]);
      let week = Number.parseInt(holiday[1]);
      year = Number.parseInt(year);
      let day = Number.parseInt(holiday[2]);
      const firstDay = 1;
      if (week < 0) {
        month++;
      }
      const date = new Date(year, month, week * 7 + firstDay);
      if (day < date.getDay()) {
        day += 7;
      }
      date.setDate(date.getDate() - date.getDay() + day);
      return date;
    },
    getDateString(e, year) {
      let holiday = holidays[0].holidays[e + ""];
      holiday = holiday.split(",");
      const date = this.getDate(year, holiday);
      let format4 =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      return format4;
    },
  },
};
</script>
<style>
.v-date-picker-table--date tbody tr td {
  &:nth-child(1) {
    .v-btn--disabled {
      .v-btn__content {
        color: #ff0000;
      }
    }
    .v-btn__content {
      color: #ff0000;
    }
  }
  /* &:nth-child(7) {
  .v-btn--disabled {
    .v-btn__content {
      color: #ff0000;
    }
  }
  .v-btn__content {
    color: #ff0000;
  }
} */
}
.v-date-picker-table .v-btn .v-date-picker-table__events {
  opacity: 0;
}
.v-text-field .v-input__slot {
  min-height: 40px !important;
}
</style>
